import { render } from "./a-intro-section.vue?vue&type=template&id=3813f480&scoped=true"
import script from "./a-intro-section.vue?vue&type=script&lang=js"
export * from "./a-intro-section.vue?vue&type=script&lang=js"

import "./a-intro-section.vue?vue&type=style&index=0&id=3813f480&lang=sass&scoped=true"

import exportComponent from "/opt/bitnami/apps/ocmsta/subdomains/academy/htdocs/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3813f480"]])

export default __exports__